export enum UserAccessTypes {
    full = 'full',
    partial = 'partial',
    none = 'none',
}
